<div>
    <p-table [value]="horas" [lazy]="true" (onLazyLoad)="loadHoras($event)" [paginator]="true" [rows]="100" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [rowsPerPageOptions]="[20, 50, 100]" [totalRecords]="totalRecords" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"  [scrollable]="true" scrollHeight="40.5rem" [resizableColumns]="true" [tableStyle]="{'font-size':'.9rem', 'font-weight':'400', 'border-spacing':'0 0 !important', 'border-colapse': 'separate'}"  #dt>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="instancia">Instância <p-sortIcon field="instancia"></p-sortIcon></th>
            <th pSortableColumn="cdEmpresaErp">Empresa ERP <p-sortIcon field="cdEmpresaErp"></p-sortIcon></th>
            <th pSortableColumn="cdFilialErp">Filial ERP <p-sortIcon field="cdFilialErp"></p-sortIcon></th>
            <th pSortableColumn="dtRefer">Data Referência <p-sortIcon field="dtRefer"></p-sortIcon></th>
            <th pSortableColumn="cdDocErp">Doc Erp <p-sortIcon field="cdDocErp"></p-sortIcon></th>
            <th pSortableColumn="cdEquiptoErp">Equipamento ERP <p-sortIcon field="cdEquiptoErp"></p-sortIcon></th>
            <th pSortableColumn="cdFuncErp">Funcionário ERP <p-sortIcon field="cdFuncErp"></p-sortIcon></th>
            <th pSortableColumn="fgTpHoras">Tipo Horas <p-sortIcon field="fgTpHoras"></p-sortIcon></th>
            <th pSortableColumn="cdCcustoErp">Centro Custo ERP <p-sortIcon field="cdCcustoErp"></p-sortIcon></th>
            <th pSortableColumn="qtHoras">Empresa PIMS <p-sortIcon field="qtHoras"></p-sortIcon></th>
            <th pSortableColumn="vlTotal">Data Última Atualização <p-sortIcon field="vlTotal"></p-sortIcon></th>
            <th pSortableColumn="dtRecebido">Data Recebido <p-sortIcon field="dtRecebido"></p-sortIcon></th>
            <th pSortableColumn="fgStatusInteg">Status Integração <p-sortIcon field="fgStatusInteg"></p-sortIcon></th>
            <th pSortableColumn="deMensagemInteg">Mensagem Integração <p-sortIcon field="deMensagemInteg"></p-sortIcon></th>
            <th pSortableColumn="dtIntegPims">Data Integração PIMS <p-sortIcon field="dtIntegPims"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-hora>
          <tr>
            <td>{{ hora.instancia }}</td>
            <td>{{ hora.cdEmpresaErp }}</td>
            <td>{{ hora.cdFilialErp }}</td>
            <td>{{ hora.dtRefer | date: 'dd/MM/yyyy' }}</td>
            <td>{{ hora.cdDocErp }}</td>
            <td>{{ hora.cdEquiptoErp }}</td>
            <td>{{ hora.cdFuncErp }}</td>
            <td>{{ hora.fgTpHoras }}</td>
            <td>{{ hora.cdCcustoErp }}</td>
            <td>{{ hora.qtHoras.toLocaleString("pt-BR") }}</td>
            <td>{{ hora.vlTotal.toLocaleString("pt-BR") }}</td>
            <td>{{ hora.dtRecebido | date: 'dd/MM/yyyy' }}</td>
            <td><app-tag-status [status]="hora.fgStatusInteg"></app-tag-status></td>
            <td>{{ hora.deMensagemInteg }}</td>
            <td>{{ hora.dtIntegPims | date: 'dd/MM/yyyy' }}</td>
            
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <td colspan="21">Nenhum registro encontrado</td>
      </ng-template>
      </p-table>
</div>